var map = {
	"./home-entertainment.de-CH.json": 1452,
	"./home-entertainment.de-DE.json": 1453,
	"./home-entertainment.en-CA.json": 1454,
	"./home-entertainment.en-GB.json": 1455,
	"./home-entertainment.en-IN.json": 1456,
	"./home-entertainment.en-ME.json": 1457,
	"./home-entertainment.en-US.json": 1458,
	"./home-entertainment.es-EM.json": 1459,
	"./home-entertainment.es-ES.json": 1460,
	"./home-entertainment.fr-BE.json": 1461,
	"./home-entertainment.fr-CA.json": 1462,
	"./home-entertainment.fr-CH.json": 1463,
	"./home-entertainment.nl-BE.json": 1464,
	"./home-entertainment.nl-NL.json": 1465,
	"./home-entertainment.pl-PL.json": 1466,
	"./home-entertainment.pt-BR.json": 1467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1451;